module.exports = {
	"OceanDragon": {
		"title": "跑跑姜饼人：烤箱大逃亡",
		"description": "点击链接领取传奇宠物&水晶！",
		"gift": "邀你一起玩《跑跑姜饼人：烤箱大逃亡》",
		"gift_no_name": "신규유저와 복귀유저 모두 크리스탈 선물을 드려요!",
		"download_now": "您还没安装《跑跑姜饼人：烤箱大逃亡》吗？<br>快去下载吧！",
		"how_to_get_reward": "奖励获得方式",
		"install_cro": "安装《跑跑姜饼人：烤箱大逃亡》",
		"claim_reward": "按下“领礼物去”按钮",
		"rewards": "* 선물 : 크리스탈 1천개 + 푸른 회오리용",
		"mission": "<strong>미션!</strong> 떼탈출 에피소드1에서 스테이지1-5까지 달리기!",
		"condition": "仅限新玩家/回归玩家可获得奖励。",
		"new_player": "* 新玩家：邀请活动期间，首次加入跑跑姜饼人的玩家。",
		"old_player": "* 回归玩家：30天以上未登入跑跑姜饼人的玩家再次回来游戏。"
	},
	"2ndAnniversary": {
		"title": "跑跑姜饼人：烤箱大逃亡",
		"description": "点击链接领取传奇宠物&水晶！",
		"gift": "邀你一起玩《跑跑姜饼人：烤箱大逃亡》",
		"gift_no_name": "신규유저와 복귀유저 모두 크리스탈 선물을 드려요!",
		"download_now": "您还没安装《跑跑姜饼人：烤箱大逃亡》吗？<br>快去下载吧！",
		"how_to_get_reward": "奖励获得方式",
		"install_cro": "安装《跑跑姜饼人：烤箱大逃亡》",
		"claim_reward": "按下“领礼物去”按钮",
		"rewards": "* 선물 : 크리스탈 2,222개 + 푸른 회오리용",
		"mission": "<strong>미션!</strong> 떼탈출 에피소드1에서 스테이지1-5까지 달리기!",
		"condition": "仅限新玩家/回归玩家可获得奖励。",
		"new_player": "* 新玩家：邀请活动期间，首次加入跑跑姜饼人的玩家。",
		"old_player": "* 回归玩家：30天以上未登入跑跑姜饼人的玩家再次回来游戏。"
	},
	"MoonLight": {
		"title": "跑跑姜饼人：烤箱大逃亡",
		"description": "링크를 눌러서 레전드 쿠키와 크리스탈을 받으세요!",
		"gift": "邀你一起玩《跑跑姜饼人：烤箱大逃亡》",
		"gift_no_name": "신규유저와 복귀유저 모두 크리스탈 선물을 드려요!",
		"download_now": "您还没安装《跑跑姜饼人：烤箱大逃亡》吗？<br>快去下载吧！",
		"how_to_get_reward": "奖励获得方式",
		"install_cro": "安装《跑跑姜饼人：烤箱大逃亡》",
		"claim_reward": "按下“领礼物去”按钮",
		"rewards": "* 선물 : 크리스탈 1천개 + 달빛술사 쿠키",
		"mission": "<strong>미션!</strong> 떼탈출 에피소드1에서 스테이지1-5까지 달리기!",
		"condition": "仅限新玩家/回归玩家可获得奖励。",
		"new_player": "* 新玩家：邀请活动期间，首次加入跑跑姜饼人的玩家。",
		"old_player": "* 回归玩家：30天以上未登入跑跑姜饼人的玩家再次回来游戏。"
	},
	"FireSpirit": {
		"title": "跑跑姜饼人：烤箱大逃亡",
		"description": "링크를 눌러서 레전드 쿠키와 크리스탈을 받으세요!",
		"gift": "邀你一起玩《跑跑姜饼人：烤箱大逃亡》",
		"gift_no_name": "신규유저와 복귀유저 모두 크리스탈 선물을 드려요!",
		"download_now": "您还没安装《跑跑姜饼人：烤箱大逃亡》吗？<br>快去下载吧！",
		"how_to_get_reward": "奖励获得方式",
		"install_cro": "安装《跑跑姜饼人：烤箱大逃亡》",
		"claim_reward": "按下“领礼物去”按钮",
		"rewards": "* 선물 : 크리스탈 1천개 + 불꽃정령 쿠키",
		"mission": "<strong>任务</strong> 进入奖杯赛大厅！",
		"condition": "仅限新玩家/回归玩家可获得奖励。",
		"new_player": "* 新玩家：邀请活动期间，首次加入跑跑姜饼人的玩家。",
		"old_player": "* 回归玩家：30天以上未登入跑跑姜饼人的玩家再次回来游戏。"
	},
	"RainbowCube": {
		"title": "跑跑姜饼人：烤箱大逃亡",
		"description": "링크를 눌러 무지개큐브와 크리스탈을 받으세요!",
		"gift": "邀你一起玩《跑跑姜饼人：烤箱大逃亡》",
		"gift_no_name": "신규유저와 복귀유저 모두 크리스탈 선물을 드려요!",
		"download_now": "您还没安装《跑跑姜饼人：烤箱大逃亡》吗？<br>快去下载吧！",
		"how_to_get_reward": "奖励获得方式",
		"install_cro": "安装《跑跑姜饼人：烤箱大逃亡》",
		"claim_reward": "按下“领礼物去”按钮",
		"rewards": "* 선물 : 크리스탈 3,000개 + 무지개큐브 1,000개",
		"mission": "<strong>任务</strong> 进入奖杯赛大厅！",
		"condition": "仅限新玩家/回归玩家可获得奖励。",
		"new_player": "* 新玩家：邀请活动期间，首次加入跑跑姜饼人的玩家。",
		"old_player": "* 回归玩家：30天以上未登入跑跑姜饼人的玩家再次回来游戏。"
	},
	"JellySkin": {
		"title": "跑跑姜饼人：烤箱大逃亡",
		"description": "링크를 눌러 무지개큐브와 크리스탈을 받으세요!",
		"gift": "邀你一起玩《跑跑姜饼人：烤箱大逃亡》",
		"gift_no_name": "신규유저와 복귀유저 모두 크리스탈과 무지개큐브 선물을 드려요!",
		"download_now": "您还没安装《跑跑姜饼人：烤箱大逃亡》吗？<br>快去下载吧！",
		"how_to_get_reward": "奖励获得方式",
		"install_cro": "安装《跑跑姜饼人：烤箱大逃亡》",
		"claim_reward": "按下“领礼物去”按钮",
		"rewards": "* 선물 : 크리스탈 3,000개 + 무지개큐브 1,000개",
		"mission": "<strong>任务</strong> 进入奖杯赛大厅！",
		"condition": "仅限新玩家/回归玩家可获得奖励。",
		"new_player": "* 新玩家：邀请活动期间，首次加入跑跑姜饼人的玩家。",
		"old_player": "* 回归玩家：30天以上未登入跑跑姜饼人的玩家再次回来游戏。"
	},
	"Yeti": {
		"title": "跑跑姜饼人：烤箱大逃亡",
		"description": "点击链接领取传奇宠物&水晶！",
		"gift": "邀你一起玩《跑跑姜饼人：烤箱大逃亡》",
		"gift_no_name": "新玩家、回归玩家都可以获得水晶&传奇宠物！",
		"download_now": "您还没安装《跑跑姜饼人：烤箱大逃亡》吗？<br>快去下载吧！",
		"how_to_get_reward": "奖励获得方式",
		"install_cro": "安装《跑跑姜饼人：烤箱大逃亡》",
		"claim_reward": "按下“领礼物去”按钮",
		"rewards": "* 선물 : 크리스탈 1,000개 + 눈폭풍 예티",
		"mission": "<strong>任务</strong> 进入奖杯赛大厅！",
		"condition": "仅限新玩家/回归玩家可获得奖励。",
		"new_player": "* 新玩家：邀请活动期间，首次加入跑跑姜饼人的玩家。",
		"old_player": "* 回归玩家：30天以上未登入跑跑姜饼人的玩家再次回来游戏。"
	},
	"DreamCatcher": {
		"title": "跑跑姜饼人：烤箱大逃亡",
		"description": "点击链接领取传奇宠物&水晶！",
		"gift": "邀你一起玩《跑跑姜饼人：烤箱大逃亡》",
		"gift_no_name": "新玩家、回归玩家都可以获得水晶&传奇宠物！",
		"download_now": "您还没安装《跑跑姜饼人：烤箱大逃亡》吗？<br>快去下载吧！",
		"how_to_get_reward": "奖励获得方式",
		"install_cro": "安装《跑跑姜饼人：烤箱大逃亡》",
		"claim_reward": "按下“领礼物去”按钮",
		"rewards": "* 礼物：水晶1,000颗 ＋星光捕梦网",
		"mission": "<strong>任务</strong> 进入奖杯赛大厅！",
		"condition": "仅限新玩家/回归玩家可获得奖励。",
		"new_player": "* 新玩家：邀请活动期间，首次加入跑跑姜饼人的玩家。",
		"old_player": "* 回归玩家：30天以上未登入跑跑姜饼人的玩家再次回来游戏。"
	},
	"WaveDrop": {
		"title": "跑跑姜饼人：烤箱大逃亡",
		"description": "点击链接领取传奇宠物&水晶！",
		"gift": "邀你一起玩《跑跑姜饼人：烤箱大逃亡》",
		"gift_no_name": "新玩家、回归玩家都可以获得水晶&传奇宠物！",
		"download_now": "您还没安装《跑跑姜饼人：烤箱大逃亡》吗？<br>快去下载吧！",
		"how_to_get_reward": "奖励获得方式",
		"install_cro": "安装《跑跑姜饼人：烤箱大逃亡》",
		"claim_reward": "按下“领礼物去”按钮",
		"rewards": "* 礼物：1,000颗水晶 + 海浪滴露",
		"mission": "<strong>任务</strong> 进入奖杯赛大厅！",
		"condition": "仅限新玩家/回归玩家可获得奖励。",
		"new_player": "* 新玩家：邀请活动期间，首次加入跑跑姜饼人的玩家。",
		"old_player": "* 回归玩家：30天以上未登入跑跑姜饼人的玩家再次回来游戏。"
	},
	"JellySkin02": {
		"title": "跑跑姜饼人：烤箱大逃亡",
		"description": "点击链接领取水晶和宇宙甜甜圈！",
		"gift": "邀你一起玩《跑跑姜饼人：烤箱大逃亡》",
		"gift_no_name": "新玩家与回归玩家都能获得<br />宇宙甜甜圈、太空迷你球和水晶唷！",
		"download_now": "您还没安装《跑跑姜饼人：烤箱大逃亡》吗？<br>快去下载吧！",
		"how_to_get_reward": "奖励获得方式",
		"install_cro": "安装《跑跑姜饼人：烤箱大逃亡》",
		"claim_reward": "按下“领礼物去”按钮",
		"rewards": "* 礼物：1,000颗水晶+宇宙甜甜圈X20+太空迷你球X20",
		"mission": "<strong>任务</strong> 进入奖杯赛大厅！",
		"condition": "仅限新玩家/回归玩家可获得奖励。",
		"new_player": "* 新玩家：邀请活动期间，首次加入跑跑姜饼人的玩家。",
		"old_player": "* 回归玩家：30天以上未登入跑跑姜饼人的玩家再次回来游戏。"
	}
};